import React from 'react';
import './_charts.scss';

const HeatmapChart = ({ data, title, height = 300 }) => {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const hours = Array.from({ length: 24 }, (_, i) => i);

  const getHeatmapData = () => {
    const heatmap = Array(7).fill().map(() => Array(24).fill(0));
    
    data.forEach(item => {
      const day = item.day_of_week;
      const hour = item.hour;
      if (day >= 0 && day < 7 && hour >= 0 && hour < 24) {
        heatmap[day][hour] = item.bookings_count;
      }
    });

    return heatmap;
  };

  const getMaxValue = () => {
    return Math.max(...data.map(item => item.bookings_count), 1);
  };

  const getColorIntensity = (value, maxValue) => {
    const intensity = value / maxValue;
    const alpha = Math.max(0.1, intensity);
    return `rgba(0, 123, 255, ${alpha})`;
  };

  const heatmapData = getHeatmapData();
  const maxValue = getMaxValue();

  return (
    <div className="chart-container">
      <h6 className="chart-title">{title}</h6>
      <div className="heatmap-chart" style={{ height: height }}>
        <div className="heatmap-grid">
          <div className="heatmap-header">
            <div className="heatmap-corner"></div>
            {hours.map(hour => (
              <div key={hour} className="heatmap-hour">
                {hour}:00
              </div>
            ))}
          </div>
          {days.map((day, dayIndex) => (
            <div key={day} className="heatmap-row">
              <div className="heatmap-day">{day}</div>
              {hours.map(hour => (
                <div
                  key={`${dayIndex}-${hour}`}
                  className="heatmap-cell"
                  style={{
                    backgroundColor: getColorIntensity(heatmapData[dayIndex][hour], maxValue)
                  }}
                  title={`${day} ${hour}:00 - ${heatmapData[dayIndex][hour]} bookings`}
                >
                  {heatmapData[dayIndex][hour] > 0 && (
                    <span className="heatmap-value">{heatmapData[dayIndex][hour]}</span>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className="heatmap-legend">
          <span>Less</span>
          <div className="heatmap-legend-gradient"></div>
          <span>More</span>
        </div>
      </div>
    </div>
  );
};

export default HeatmapChart;
